<div class="containerBox">
  <div class="progress-container col-10">
    <div class="progress" #progress></div>
    <div class="circle" *ngFor="let step of steps; let i = index"
      [ngClass]="{'hand':currentTab == tabName.SOURCING,'active': i + 1 === currentActive, 'completed': currentTab == tabName.SOURCING ? (completedSteps && completedSteps[i]) : (i + 1 < currentActive || data?.moveToEnd && currentActive == 6)}"
      (click)="currentTab == tabName.SOURCING ? onStepChange(step) : null">
      <ng-container
        *ngIf="currentTab == tabName.SOURCING ? (completedSteps && completedSteps[i]) : (i + 1 < currentActive || data?.moveToEnd && currentActive == 6)">
        <svg xmlns="http://www.w3.org/2000/svg" width="15.506" height="14" viewBox="0 0 15.506 14">
          <path id="Path_1487" data-name="Path 1487"
            d="M15.145,72.24a1.063,1.063,0,0,0-1.739,0L5.578,82.062,2.1,77.7a1.063,1.063,0,0,0-1.739,0,1.833,1.833,0,0,0,0,2.183l4.349,5.456a1.063,1.063,0,0,0,1.739,0l8.7-10.913A1.833,1.833,0,0,0,15.145,72.24Z"
            transform="translate(0.001 -71.788)" fill="#fff" />
        </svg>
      </ng-container>
      <ng-container>
        <div class="label popup-secondary-text text-light-gray text-nowrap">{{ step }}</div>
      </ng-container>
    </div>
  </div>
</div>
<div>
  <ng-content select="app-common-progress-step"></ng-content>
</div>
<div class="row row-gap-1 mx-0 p-0 justify-content-center w-100">
  <div *ngIf="currentActive == 2 && currentTab != tabName.SOURCING" class="col-10 col-lg-auto col-xl-6 p-0">
    <div class="d-flex gap-2 gap-xl-4">
      <div class="font-11 text-red fw-bold">You have {{unmappedSystemColumnsCount}} unmapped columns</div>
      <div class="font-11 text-red fw-bold">You have {{data?.mapData?.unmappedUploadedColumns?.length}} unmapped
        headers.
        <span class="text-secondary-color link hand font-11 text-decoration-underline bg-transparent"
          (click)="openUnmappedModal()">View</span>
      </div>
    </div>
    <div class="font-11 text-light-gray">Unmapped columns do not get imported.</div>
  </div>
  <div *ngIf="currentActive == 4 && currentTab != tabName.SOURCING" class="col-10 col-lg-auto col-xl-6 p-0">
    <div class="positionChange" *ngIf="!data?.errorData?.isDuplicate && !data?.errorData?.importError">
      <div class="font-11 text-red fw-bold">You have {{data?.errorData?.rowData?.length ?? '0'}} errors</div>
      <div class="font-11 text-light-gray">Error rows do not get imported.</div>
    </div>
    <div class="positionChange"
      *ngIf="data?.errorData?.isDuplicate && (data?.errorData?.duplicateData?.rowData?.length > 0)">
      <div class="font-11 text-red fw-bold">You have {{data?.errorData?.duplicateData?.rowData?.length ?? '0'}}
        potential duplicates.</div>
      <div class="font-11 text-light-gray">Potential duplicates do not get imported unless Import is checked.</div>
    </div>
  </div>
 
  <div [ngClass]="{'d-none':currentActive == 5 || currentTab == tabName.SOURCING }"
    class="{{currentActive == 2 || currentActive == 4?'col-lg col-xl-4':''}} col-10 d-flex p-0 gap-3 justify-content-end">
    <app-button [button_2]="true" [buttonClass]="'button button-info mx-0'" [buttonLable]="enumButtonName.CANCEL"
      (click)="onCancel()">
    </app-button>
    <app-button *ngIf="currentActive !== 1" [button_2]="true" [buttonClass]="'button  dark-info mx-0'"
      [buttonLable]="enumButtonName.PREVIOUS"
      (click)="currentActive == 4 && data?.errorData?.isDuplicate?onCurrentTab():onPrevClick()"
      [inputReadonly]="currentActive === 1">
    </app-button>
    <app-button (click)="handleClick()" [button_2]="true"
      [buttonClass]="'button mx-0 ' + (isNextButtonDisabled() ? 'button-danger' : 'button-primary')"
      [buttonLable]="currentActive == 4 && data?.errorData?.isDuplicate?enumButtonName.COMPLETEIMPORT:enumButtonName.NEXT"
      [inputReadonly]="isNextButtonDisabled()">
    </app-button>
  </div>
</div>